import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Colors } from '../../styles/Colors';
import classNames from 'classnames';

const useStyle = makeStyles(() => ({
    container: {
        display: 'flex',
        color: Colors.Text3,
        fontSize: 14,
        fontWeight: 400,
        width: 60,
        maxWidth:80,
        gap: 2,
        height: 'fit-content',
    },
    active: {
        color: Colors.Primary,
    },
    interactive: {
        cursor: 'pointer',
    },
}));

interface StartTimeSlotInterface {
    time1: string;
    active: boolean;
    interactive: boolean;
    onClick?: () => void;
}

const StartTimeSlot: React.VFC<StartTimeSlotInterface> = ({
    onClick,
    time1,
    active = false,
    interactive = false,
}) => {
    const classes = useStyle();

    return (
        <div
            onClick={interactive && onClick ? onClick : undefined}
            className={classNames(
                classes.container,
                active && classes.active,
                interactive && classes.interactive,
            )}
        >
            <span>{time1}</span>
        </div>
    );
};

export default StartTimeSlot;
